﻿/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Plugin } from '@ckeditor/ckeditor5-core';

import GameInputEditing from './gameinputediting';
import GameInputUI from './gameinputui';


export default class GameInput extends Plugin {
    static get requires() {
        return [GameInputEditing, GameInputUI];
    }
}